/**
 * NFR-7: "The custom toolbar has role="toolbar" and moves focus with Left/Right arrow keys".
 * Right and Left step to the next and previous control, wrapping at the ends (the WAI-ARIA toolbar
 * pattern); Home and End go to the first and last. Any other key is the control's own.
 */
export function toolbarTarget(key: string, current: number, count: number): number | null {
  if (count === 0 || current < 0) return null;
  switch (key) {
    case 'ArrowRight':
      return (current + 1) % count;
    case 'ArrowLeft':
      return (current - 1 + count) % count;
    case 'Home':
      return 0;
    case 'End':
      return count - 1;
    default:
      return null;
  }
}

/**
 * How many of the toolbar's items fit in `available` pixels, in order, given each item's
 * `widths[i]` (separators are `null` items). Everything, if it all fits. Otherwise as many as fit
 * beside "More tools" (`moreWidth`), never ending on a separator. An item never measured stops the
 * count, since its width is not known.
 */
export function toolbarFit(items: readonly unknown[], widths: readonly (number | undefined)[], available: number, moreWidth: number): number {
  let total = 0;
  let all = true;
  for (let i = 0; i < items.length; i++) {
    if (widths[i] === undefined) {
      all = false;
      break;
    }
    total += widths[i]!;
  }
  if (all && total <= available) return items.length;
  let used = moreWidth;
  let shown = 0;
  while (shown < items.length && widths[shown] !== undefined && used + widths[shown]! <= available) used += widths[shown++]!;
  while (shown > 0 && items[shown - 1] === null) shown--;
  return shown;
}
